import { UserAuthorities } from "models/auth/types";

export function authoritiesIncludeGroup(
	authorities: UserAuthorities[],
	roleGroup: string
) {
	return !!authorities.find(
		(ug) =>
			ug === UserAuthorities.ADMINISTRADOR ||
			ug.replace("ROLE_", "") === roleGroup
	);
}
